import { css } from "lit";

export const styles = css`
  :host {
    display: inline-flex;
  }

  .live-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    background: var(--sds-color-background-danger-default);
    color: white;
    border-radius: var(--sds-border-radius-pill);
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .live-badge.paused {
    background: var(--sds-color-background-warning-default);
  }

  .live-badge.preview {
    background: var(--sds-color-background-neutral-bold);
  }

  .live-indicator {
    width: 8px;
    height: 8px;
    background: white;
    border-radius: 50%;
    animation: pulse 1.5s infinite;
  }

  .live-badge.paused .live-indicator,
  .live-badge.preview .live-indicator {
    animation: none;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;
